import { doc, getDoc, setDoc, updateDoc, serverTimestamp } from "firebase/firestore";
import { db } from "./firebase";

/**
 * 🔍 GET produit local
 */
export async function getProduct(code) {
  const ref = doc(db, "products", code);
  const snap = await getDoc(ref);

  if (!snap.exists()) return null;

  return snap.data();
}

/**
 * 💾 SAVE / UPDATE produit
 */
export async function saveProduct(code, data) {
  const ref = doc(db, "products", code);

  await setDoc(ref, {
    ...data,
    lastUsed: Date.now(),
  }, { merge: true });
}

/**
 * 🔄 UPDATE lastUsed uniquement
 */
export async function updateLastUsed(code) {
  const ref = doc(db, "products", code);

  await updateDoc(ref, {
    lastUsed: Date.now(),
  });
}